module.exports = __webpack_public_path__ + "static/img/gc_specific.f14aa17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giftc/gc_specific.png
// module id = 309
// module chunks = 1